export default __webpack_public_path__ + "static/media/animation004-1.77de042f.png";